import { useEffect, useState } from "react";

const Photo = () => {
	const [data, setData] = useState({
		image_count: 1,
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		setData((preData) => ({
			...preData,
			[name]: value,
		}));
	};
	useEffect(() => {
		console.log(data);
	}, [data]);

	const handleSubmit = (e) => {
		e.preventDefault();
		setData({});
	};

	return (
		<div className="py-4 mb-8">
			{JSON.stringify(data, null, 2)}
			<form
				onSubmit={handleSubmit}
				id="uploadForm"
				className="max-w-lg mx-auto"
			>
				<div>
					{/* Navigation Buttons */}
					<div className="flex justify-end mb-4">
						<a
							className="btn-primary bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded mx-2"
							href="/multiple"
						>
							Multiple Image
						</a>
						<a
							className="btn-success bg-green-500 hover:bg-green-700 text-white py-2 px-4 rounded"
							href="https://www.remove.bg/"
						>
							Background Remove
						</a>
					</div>

					{/* Form Inputs */}
					<div className="space-y-4">
						{/* File Input */}
						<div>
							<label className="block text-gray-700 font-medium mb-2">
								Select one or more Images
							</label>
							<input
								className="block w-full border border-gray-300 rounded px-3 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
								type="file"
								id="imageUpload1"
								accept="image/*"
								multiple
								name="image"
								onChange={handleChange}
								value={data?.image || undefined}
								required
							/>
						</div>

						{/* Select Size */}
						<div>
							<label className="block text-gray-700 font-medium mb-2">
								Set Size
							</label>
							<select
								className="block w-full border border-gray-300 rounded px-3 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
								id="size"
								required
								name="size"
								value={""}
								onChange={handleChange}
							>
								<option value="passport">Passport Size</option>
								<option value="landscape">
									Passport Landscape (4)
								</option>
								<option value="stamp">Stamp Size</option>
								<option value="2x4">
									2x4 in (NGO Combine Photo)
								</option>
								<option value="2x2">
									2x2 in (Indian Visa Size)
								</option>
								<option value="nid">NID (2 Image)</option>
								<option value="nid_combined">
									NID Combined (1 Image)
								</option>
								<option value="mrp">MRP Passport</option>
								<option value="bordered">
									A4 with 0.5 Inch Border
								</option>
								<option value="3R">
									3R Photo (Album Size)
								</option>
							</select>
						</div>

						{/* Image Count */}
						<div>
							<label className="block text-gray-700 font-medium mb-2">
								Set Count
							</label>
							<input
								className="block w-full border border-gray-300 rounded px-3 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
								min={1}
								max={20}
								type="number"
								id="imageCount1"
								name="image_count"
								value={data?.image_count || undefined}
								onChange={handleChange}
								required
							/>
						</div>

						{/* Submit Button */}
						<div>
							<button
								className="w-full bg-green-500 hover:bg-green-700 text-white py-2 px-4 rounded"
								type="submit"
							>
								Submit
							</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	);
};

export default Photo;
